<template>
  <div
    :class="[
      {
        '--with-contents':
          (withTitle && !headerHasContents) || headerHasContents,
        '--large': large,
        '--light': light
      },
      'workout-group-header w-100 p-relative'
    ]"
  >
    <h3
      v-if="withTitle"
      :class="[
        { 'pb-1': headerHasContents },
        'workout-group-header__title m-0 d-flex align-items-start'
      ]"
    >
      {{ group.title }}
    </h3>

    <div
      v-if="headerHasContents"
      :class="[
        { 'justify-content-end': alignRight },
        'workout-group-header__details p-relative z-2'
      ]"
    >
      <template v-if="$slots.detail">
        <slot name="detail"></slot>
      </template>
      <template v-else>
        <template v-if="completedRounds">
          <group-header-detail
            v-if="group.is_amrap || showGroupRounds"
            icon="cached"
          >
            <template v-if="group.is_amrap">
              {{ $t("components.workout.groupHeader.AMRAP") }}
            </template>
            <template v-if="group.is_amrap ? true : showGroupRounds">
              {{ $t("components.workout.groupHeader.round") }}
              {{ completedRounds
              }}<template v-if="!hideTotalRounds">/{{ group.rounds }}</template>
            </template>
          </group-header-detail>
        </template>
        <template v-else>
          <template v-if="group.is_amrap">
            <group-header-detail icon="cached">
              <strong>{{ $t("components.workout.groupHeader.AMRAP") }}</strong>
            </group-header-detail>
          </template>

          <template v-else-if="showGroupRounds">
            <group-header-detail icon="cached">
              <strong>{{ group.rounds }}</strong>
              {{
                group.rounds > 1
                  ? $t("components.workout.groupHeader.rounds")
                  : $t("components.workout.groupHeader.round")
              }}
            </group-header-detail>
          </template>
        </template>

        <template v-if="group.has_timer || group.is_amrap || group.is_rest">
          <group-header-detail
            v-if="group.is_rest"
            class="workout-group-header__time"
            icon="schedule"
          >
            <strong>{{ group.rest_period }}</strong>
            {{ humanInterval(group.rest_period, group.rest_interval) }}
          </group-header-detail>

          <group-header-detail
            v-else
            class="workout-group-header__time"
            icon="schedule"
          >
            <strong>{{ group.timer_period }}</strong>
            {{ humanInterval(group.timer_period, group.timer_interval) }}
          </group-header-detail>
        </template>

        <template v-if="group.is_amrap">
          <form-capture-button
            v-if="group.uid"
            :capture-uid="group.uid"
            class="ml-auto"
            @capture="startIndex => $emit('captureClicked', startIndex)"
          />
        </template>

        <slot name="buttons"></slot>
      </template>
    </div>

    <div
      class="workout-group-header__progress"
      :style="{ transform: `scaleX(${progress})` }"
    ></div>
  </div>
</template>

<script>
import GroupHeaderDetail from "@/components/workout/GroupHeaderDetail"

import { humanInterval } from "@/lib/time-utils"

export default {
  components: {
    GroupHeaderDetail,
    FormCaptureButton: () => import("@/components/workout/FormCaptureButton")
  },

  props: {
    group: { type: Object, required: true },
    progress: { type: Number, default: 0 },
    large: { type: Boolean, default: false },
    withTitle: { type: Boolean, default: true },
    hideTotalRounds: { type: Boolean, default: false },
    alignRight: { type: Boolean, default: false },
    light: { type: Boolean, default: false },
    completedRounds: { type: Number, default: null }
  },

  computed: {
    headerHasContents() {
      return (
        this.group.is_amrap ||
        this.showGroupRounds ||
        this.group.has_timer ||
        this.group.is_rest
      )
    },

    showGroupRounds() {
      return this.group.rounds && this.group.rounds > 1
    }
  },

  methods: {
    humanInterval
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.workout-group-header {
  padding: 0 $size--4;

  &.--with-contents {
    padding: $size--4 $size--4;
    padding-bottom: $size--3;
  }

  &.--light {
    background: $color-ui--white;

    .workout-group-header__progress {
      background: $color-ui--grey-20;
    }
  }

  &.--large {
    height: 60vh;
    text-align: center;

    h5 {
      font-size: $font-size--h1;
      margin-bottom: $size--2;
    }

    .workout-group-header__details {
      margin-left: 0;
      justify-content: center;
    }

    .workout-group-header__detail {
      margin-left: 0;
    }
  }
}

.workout-group-header__title {
  color: inherit;
}

.workout-group-header__progress {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: $color-ui--grey-30;
  transform: scaleX(0);
  transform-origin: 0 0;
  transition: transform 0.25s linear;
}

.workout-group-header__details {
  display: flex;
  align-items: center;

  &.--align-right {
    justify-content: flex-end;
  }
}
</style>
